module.exports = __webpack_public_path__ + "img/no-content.08a7bbb8.png";